import { render } from "./ChangePasswordModal.vue?vue&type=template&id=91b426da&scoped=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=91b426da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b426da"]])

export default __exports__